// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1IWFQ","productName":"Table_productName__1wvRv"};